import { all, fork, put, takeEvery, call, takeLatest } from 'redux-saga/effects';
import { CompanyActionTypes } from './constants';

import { getAllCompanies, getCompanyDetails, createCompany, updateCompany, deleteCompany } from './api';
/**
 * Login the user
 * @param {*} payload - username and password
 */

function* getCompanyDataFunction(data) {
    try {
        yield put({
            type: CompanyActionTypes.GET_COMPANY_DATA_LOADING,
            payload: {},
        });
        const response = yield call(getAllCompanies, data);
        if (response.data.status) {
            yield put({
                type: CompanyActionTypes.GET_COMPANY_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: CompanyActionTypes.GET_COMPANY_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: CompanyActionTypes.GET_COMPANY_DATA_ERROR,
            payload: error,
        });
    }
}

function* getCompanyDetailsDataFunction(data) {
    try {
        yield put({
            type: CompanyActionTypes.GET_COMPANY_DETAILS_DATA_LOADING,
            payload: {},
        });
        const response = yield call(getCompanyDetails, data);
        if (response.data.status) {
            yield put({
                type: CompanyActionTypes.GET_COMPANY_DETAILS_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: CompanyActionTypes.GET_COMPANY_DETAILS_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: CompanyActionTypes.GET_COMPANY_DETAILS_DATA_ERROR,
            payload: error,
        });
    }
}

function* createCompanyFunction(data) {
    try {
        yield put({
            type: CompanyActionTypes.CREATE_COMPANY_DATA_LOADING,
            payload: {},
        });
        const response = yield call(createCompany, data);
        if (response.data.status) {
            yield put({
                type: CompanyActionTypes.CREATE_COMPANY_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: CompanyActionTypes.CREATE_COMPANY_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: CompanyActionTypes.CREATE_COMPANY_DATA_ERROR,
            payload: error,
        });
    }
}
function* updateCompanyFunction(payload) {
    try {
        yield put({
            type: CompanyActionTypes.UPDATE_COMPANY_DATA_LOADING,
        });

        const response = yield call(updateCompany, payload);

        if (response && response.data && response.data.status) {
            yield put({
                type: CompanyActionTypes.UPDATE_COMPANY_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({
                type: CompanyActionTypes.UPDATE_COMPANY_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        yield put({
            type: CompanyActionTypes.UPDATE_COMPANY_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}

function* deleteCompanyFunction(payload) {
    try {
        yield put({
            type: CompanyActionTypes.DELETE_COMPANY_DATA_LOADING,
        });

        const response = yield call(deleteCompany, payload);
        if (response && response.data && response.data.status) {
            yield put({
                type: CompanyActionTypes.DELETE_COMPANY_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({
                type: CompanyActionTypes.DELETE_COMPANY_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        yield put({
            type: CompanyActionTypes.DELETE_COMPANY_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}


export function* watchcompanyDataGet() {
    yield takeLatest(CompanyActionTypes.GET_COMPANY_DATA_FIRST, getCompanyDataFunction);
    yield takeLatest(CompanyActionTypes.GET_COMPANY_DETAILS_DATA_FIRST, getCompanyDetailsDataFunction);
    yield takeEvery(CompanyActionTypes.CREATE_COMPANY_DATA_FIRST, createCompanyFunction);
    yield takeLatest(CompanyActionTypes.UPDATE_COMPANY_DATA_FIRST, updateCompanyFunction);
    yield takeEvery(CompanyActionTypes.DELETE_COMPANY_DATA_FIRST, deleteCompanyFunction);
}

function* companySaga() {
    yield all([
        fork(watchcompanyDataGet),
    ]);
}
export default companySaga;
